"use client";

import Script from "next/script";
import Head from "next/head";
import Link from "@/components/Link";

import Header from "@/components/Header";
import HeaderWrapper from "@/components/Header/HeaderWrapper";
import Footer from "@/components/Footer";
import RainbowButton from "@/components/RainbowButton";

import { buildWhatsappUrl } from "@ide/shared/lib/helpers";

// https://github.com/vercel/next.js/discussions/50034

const Error = ({ params }) => {
  return (
    <>
      <Header showInstantConsultation={false} />

      <main id="root">
        <div className="px-4">
          <div className="flex flex-col items-center max-w-root mx-auto">
            <div className="h-24 md:h-32"></div>

            <h1 className="text-3xl md:text-5xl text-center font-medium">Something went wrong!</h1>

            <div className="h-4"></div>

            <div className="flex flex-col gap-2 text-lg md:text-xl text-center">
              <p>There is a technical issue with our site right now. Please try again later.</p>

              {process.env.NEXT_PUBLIC_SHOW_WHATSAPP_NUMBER === "true" && (
                <p>
                  If you need help with something urgent, you can contact us via{" "}
                  <a
                    className="underline"
                    href={buildWhatsappUrl({
                      text: "Hi, there was something wrong with your site, so I am trying here!",
                      // phone: "",
                    })}
                  >
                    Whatsapp
                  </a>{" "}
                  anytime.
                </p>
              )}
            </div>

            <div className="h-8"></div>

            <Link
              href="/map"
              className="btn-rainbow h-12 px-8 flex justify-center items-center rounded-full text-lg"
            >
              Browse all projects
            </Link>

            <div className="h-24 md:h-32"></div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Error;
